import { useState, useEffect } from 'react'
import { Container } from "./styles"
import Button from "../../../../components/Button"
import { api } from "../../../../services/api"
import { Link, useLocation, useParams } from "react-router-dom"

const ShowClient = () => {

    const location = useLocation()
    const {id} = useParams()

	const [client, setClient] = useState(location.state?.client || {})

    useEffect(() => {
		api.get(`clients/show/${id}`)
		.then((response) => {
		setClient(response.data)	
		})
    }, [id, location])


    return (
    <Container>
		<div className="about">
        	<h1>{client?.name}</h1>
			<p><span>Email: </span>{client?.email}</p>
			<p><span>CPF: </span>{client?.cpf}</p>
			<p><span>Endereço: </span>{client?.address}</p>
        	<p><span>CEP: </span>{client?.cep}</p>
			<p><span>Telefone: </span>{client?.phone}</p>
        </div>
		<div className="buttons">
			<Link to="/manager/clients"><Button className="button">Voltar</Button></Link>
		</div>
        </Container>
    )
}

export default ShowClient
